import uniqueId from 'lodash-es/uniqueId';
import { forwardRef, useState } from 'react';
import { Box, Spinner } from '@apia/theme';
import { arrayOrArray, useMount } from '@apia/util';
import {
  TResponsiveTableRow,
  TResponsiveTableCellRenderer,
  TResponsiveTableCellRendererProps,
} from '../types';

export function makeAsyncRenderer(
  additionalInfoGetter: (row: TResponsiveTableRow) => Promise<
    {
      label?: string;
      name: string;
      newline?: boolean;
    }[]
  >,
) {
  const InnerRender: TResponsiveTableCellRenderer = forwardRef<
    HTMLElement,
    TResponsiveTableCellRendererProps
  >(({ row }, ref) => {
    const [moreInfo, setMoreInfo] = useState<
      | {
          label?: string;
          name: string;
          newline?: boolean;
        }[]
      | null
    >(null);
    useMount(() => {
      void (async () => {
        const result = await additionalInfoGetter(row);
        setMoreInfo(result);
      })();
    });

    return (
      <>
        {moreInfo ? (
          arrayOrArray(moreInfo).map((dataCell) => {
            return (
              <Box
                key={`${dataCell.name}-${uniqueId()}`}
                ref={ref}
                className={`responsiveTable__additionalInfoItem ${
                  dataCell.newline ? 'separator' : ''
                }`}
              >
                {dataCell.newline ? (
                  <>
                    <Box sx={{ height: '20px' }} as="strong">
                      {dataCell.name}:
                    </Box>{' '}
                    {dataCell.label}
                  </>
                ) : (
                  <>
                    <Box as="strong">{dataCell.name}:</Box> {dataCell.label}
                  </>
                )}
              </Box>
            );
          })
        ) : (
          <Spinner size={15} />
        )}
      </>
    );
  });

  InnerRender.displayName = 'MakeAsyncRenderer';

  return InnerRender;
}
